'use client';

import React from 'react';
import NotFound from 'components/commercetools-ui/organisms/not-found';
import { NotFoundProps } from 'components/commercetools-ui/organisms/not-found/types';
import { TasticProps } from '../types';

  const NotFoundTastic = ({ data }: TasticProps<NotFoundProps>) => {
  return <NotFound {...data} />;
};

export default NotFoundTastic;
